export const cookie ={
    methods: {
        getCookie(name){
            if (this.$cookies.isKey(name)) { 
                return this.$cookies.get(name); 
            } 
            else 
            {
                return false;
            }
        },
        setCookie(name,vaule,time) {
            /*
            time 예시
            1d                  default expire time: 1 day
            1                   1 second after, expire
            60 + 30             1 minute 30 second after, expire
            60 * 60 * 12        12 hour after, expire
            60 * 60 * 24 * 30   1 month after, expire
            0                   end of session - use 0 or "0"!
            https://www.npmjs.com/package/vue3-cookies
            */
            this.$cookies.set(name, vaule ,time);      
        },
        resetCookie(name){
            this.$cookies.remove(name)         
        },
    },
}
